<template>
  <Component :is="continuous ? 'div' : BaseCard" :class="containerClasses">
    <p id="candidateCareerPassport" class="mb-8 w-44 bg-gradient-to-r bg-clip-text font-bold text-transparent from-bdOrange-600 to-bdYellow-600">
      Career Passport.
    </p>
    <EditableFormDetailedList name="Career Passport Entry"
                              :allows="candidateCareerPassport.passport.allows"
                              :list="candidate.careerPassport" :icon="BuildingOffice2Icon" :small="small"
                              :editable="editable" @update:list="updateCandidate"/>
    <p v-if="!editable && !candidate.careerPassport?.length"
       class="-mt-2 mb-4 text-sm text-slate-400">No career passport entered yet</p>
  </Component>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";
import EditableFormDetailedList from "./EditableFormDetailedList.vue";
import {BuildingOffice2Icon} from "@heroicons/vue/24/outline/index.js";
import {computed} from "vue";
import {candidateCareerPassport} from "../helpers/ProfileQuestions.js";

const emits = defineEmits(["update:candidate"]);
const props = defineProps({
  candidate: Object,
  continuous: Boolean,
  small: Boolean,
  editable: Boolean,
});

const updateCandidate = (value) => {
  if (!props.editable) return;

  const c = {...props.candidate};
  c.careerPassport = value;
  emits("update:candidate", c);
};

const containerClasses = computed(() => {
  const baseClasses = props.continuous ? "px-4 md:px-6 mt-6" : "relative shadow-sm mt-6";
  return baseClasses + (props.small ? " text-sm" : " text-base");
});
</script>
